import type {Control, FieldValues, Path} from 'react-hook-form';

import {Input} from '@ds/components';
import {Controller} from 'react-hook-form';

type FormInputProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  label?: string;
  placeholder?: string;
  type?: React.HTMLInputTypeAttribute;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  maxLength?: number;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  inputClassName?: string;
  onValueChange?: (value: string) => void;
};

const FormInput = (<TFieldValues extends FieldValues>({
  name,
  control,
  label,
  placeholder,
  type = 'text',
  inputMode,
  maxLength,
  required,
  disabled,
  readOnly,
  prefix,
  suffix,
  inputClassName,
  onValueChange
}: FormInputProps<TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => (
        <Input
          {...field}
          id={String(name)}
          value={field.value ?? ''}
          label={label}
          placeholder={placeholder}
          type={type}
          inputMode={inputMode}
          maxLength={maxLength}
          required={required}
          disabled={disabled}
          readOnly={readOnly}
          prefix={prefix}
          suffix={suffix}
          status={error ? 'error' : undefined}
          help={error?.message}
          inputClassName={inputClassName}
          onChange={(event) => {
            field.onChange(event);
            onValueChange?.(event.target.value);
          }}
        />
      )}
    />
  );
}) satisfies React.FC<FormInputProps<FieldValues>>;

export default FormInput;
